<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>User Info</strong>
        <CButtonGroup class="float-right">
          <CButton
            v-on:click="handleManageOrganization()"
            name="manage-organization"
            color="primary"
            class="d-sm-down-none"
          >
          <CIcon name="cil-pencil"/> Organization
          </CButton>
          &nbsp;
          <CButton
            v-on:click="handleManageInfo()"
            name="manage-info"
            color="success"
            class="d-sm-down-none"
          >
          <CIcon name="cil-pencil"/> Info
          </CButton>
          
        </CButtonGroup>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <CInput
            label="ชื่อ"
            :placeholder="info.firstname"
            horizontal
            disabled
          />
          <CInput
            label="นามสกุล"
            :placeholder="info.lastname"
            horizontal
            disabled
          />
          <CInput
            label="E-mail"
            :placeholder="info.email"
            horizontal
            disabled
          />
          <CInput
            label="หน่วยงาน"
            :placeholder="info.department"
            horizontal
            disabled
          />
          <CInput
            label="โทรศัพท์"
            :placeholder="info.phone"
            horizontal
            disabled
          />
          <CInput
            label="โทรศัพท์ (ต่อ)"
            :placeholder="info.phone_ext"
            horizontal
            disabled
          />
          <CInput
            label="องค์กร"
            :placeholder="organization.nameTH"
            horizontal
            disabled
          />
          <!-- <CInput
            label="Organization"
            :placeholder="organization.nameEN"
            horizontal
            disabled
          /> -->
        </CForm>
      </CCardBody>
    </CCard>

    <CModal
      :show.sync="isManageInfo"
      :centered="false"
      color="success"
      title="User Info Management"
      size="lg"
    >
      <CForm>
        <CInput
          v-model="selectedInfo.firstname"
          type="text"
          label="ชื่อ"
          placeholder="Enter First Name..."
          horizontal
          required
          autocomplete="given-name"
          :is-valid="isValidInfo('firstname')"
          :invalid-feedback="feedback.firstname"
        />
        <CInput
          v-model="selectedInfo.lastname"
          type="text"
          label="นามสกุล"
          placeholder="Enter Lastname Name..."
          horizontal
          required
          autocomplete="family-name"
          :is-valid="isValidInfo('lastname')"
          :invalid-feedback="feedback.lastname"
        />
        <CInput
          v-model="selectedInfo.email"
          type="text"
          label="E-mail"
          placeholder="Enter E-mail..."
          horizontal
          required
          autocomplete="email"
          :is-valid="isValidInfo('email')"
          :invalid-feedback="feedback.email"
        />
        <CInput
          v-model="selectedInfo.department"
          type="text"
          label="หน่วยงาน"
          placeholder="Enter Department..."
          horizontal
          required
          :is-valid="isValidInfo('department')"
          :invalid-feedback="feedback.department"
        />
        <CInput
          v-model="selectedInfo.role"
          type="text"
          label="ตำแหน่ง"
          placeholder="Enter Role..."
          horizontal
          required
          :is-valid="isValidInfo('role')"
          :invalid-feedback="feedback.role"
        />
        <CInput
          v-model="selectedInfo.phone"
          type="text"
          label="โทรศัพท์"
          placeholder="Enter Phone..."
          horizontal
          required
          autocomplete="tel"
          :is-valid="isValidInfo('phone')"
          :invalid-feedback="feedback.phone"
        />
        <CInput
          v-model="selectedInfo.phone_ext"
          type="text"
          label="โทรศัพท์ (ต่อ)"
          placeholder="Enter Phone-Extention..."
          horizontal
          required
          autocomplete="tel-extension"
          :is-valid="isValidInfo('phone_ext')"
          :invalid-feedback="feedback.phone_ext"
        />
      </CForm>
      <template #footer>
        <CButton v-on:click="isManageInfo = false" color="light">Cancel</CButton>
        <CButton 
          v-on:click="isManageInfo = false; handleCreateOrUpdateInfo();" 
          color="success"
          :disabled="!isValidSelectedInfo"
        >
          Save
        </CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="isManageOrganization"
      :centered="false"
      color="primary"
      title="Organization Management"
      size="xl"
    >
      <CCard
        title="Organization"
      >
        <CCardHeader>
          <CRow>
            <CCol col=4>
              <CIcon size="2xl" name="cil-grid"/> Organization
            </CCol>
            <CCol col=8 class="align-right">
              <CButtonToolbar>
                <input 
                  class="search" 
                  type="search"
                  v-model="findKeyword"
                  v-on:input="handleKeyword"
                  placeholder="ค้นหา องค์กร"
                >
                &nbsp;
                <CButtonGroup>
                  <CButton
                    v-on:click="isCreateOrEditOrganization = true; isManageOrganization = false; selectedOrganization = {};"
                    name="manage"
                    color="primary"
                    class="d-sm-down-none"
                  >
                    Create
                  </CButton>
                  &nbsp;
                  <CButton
                    v-if="isOrganizationExist"
                    v-on:click="isCreateOrEditOrganization = true; isManageOrganization = false;"
                    name="manage"
                    color="success"
                    class="d-sm-down-none"
                  >
                    <CIcon name="cil-pencil"/> Edit
                  </CButton>
                </CButtonGroup>
              </CButtonToolbar>
            </CCol>
          </CRow>

        </CCardHeader>
        <CCardBody>
          <CDataTable
            :hover="false"
            :striped="true"
            :border="true"
            :small="false"
            :fixed="false"
            :items-per-page="20"
            :dark="false"
            pagination
            :items="organizationsTable"
            :fields="organizationsTableFields"
          >
            <!-- <template #nameTH="{item}">
              <td>
                {{item.nameTH}}
              </td>
            </template> -->
            <!-- <template #nameEN="{item}">
              <td>
                {{item.nameEN}}
              </td>
            </template> -->
            <!-- <template #nameShortTH="{item}">
              <td>
                {{item.nameShortTH}}
              </td>
            </template>
            <template #nameShortEN="{item}">
              <td>
                {{item.nameShortEN}}
              </td>
            </template> -->
            <template #operation="{item}">
              <td>
                <CButton
                  v-on:click="updateOrganizationOfUser(item)"
                  name="manage"
                  size="sm"
                  color="primary"
                >
                  Select
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
        <!-- <CCardFooter>
          <CRow>
            <CCol sm="6" md="1">
              <CSwitch class="mx-1" color="primary" v-on:update:checked="toggleDelete" :checked="!isDeletabled" variant="opposite" shape="pill" labelOn='yes' labelOff='no' />
            </CCol>
            <CCol sm="6" md="11">
              <p>Prevent Delete CCTV</p>
            </CCol>
          </CRow>
        </CCardFooter> -->
      </CCard>
      <!-- <template #footer>
        <CButton v-on:click="isManageOrganization = false" color="light">Cancel</CButton>
        <CButton v-on:click="isManageOrganization = false; handleCreateOrUpdateInfo();" disabled color="success">Save</CButton>
      </template> -->
    </CModal>

    <div
      v-if="!isManageOrganization"
    >
      <CModal
        :show.sync="isCreateOrEditOrganization"
        :centered="false"
        color="primary"
        title="Organization Information"
        size="lg"
      >
        <CForm>
          <CInput
            v-model="selectedOrganization.nameTH"
            type="text"
            label="องค์กร"
            placeholder="Enter Organization TH..."
            horizontal
            required
            :is-valid="isValidOrganization('nameTH')"
            :invalid-feedback="feedback.nameTH"
          />
          <!-- <CInput
            v-model="selectedOrganization.nameEN"
            type="text"
            label="Organization"
            placeholder="Enter Organization EN..."
            horizontal
            required
            :is-valid="isValidOrganization('nameEN')"
            :invalid-feedback="feedback.nameEN"
          /> -->
          
          <CInput
            v-model="selectedOrganization.nameShortTH"
            type="text"
            label="องค์กร (ย่อ)"
            placeholder="Enter Organization(acronym) TH..."
            horizontal
          />
          <CInput
            v-model="selectedOrganization.nameShortEN"
            type="text"
            label="Organization (acronym)"
            placeholder="Enter Organization(acronym) EN..."
            horizontal
          />
        </CForm>
        <template #footer>
          <CButton v-on:click="isCreateOrEditOrganization = false" color="light">Cancel</CButton>
          <CButton
            v-if="isNewOrganization"
            v-on:click="isCreateOrEditOrganization = false; createOrganization();"
            :disabled="!isValidSelectedOrganization"
            color="success"
          >
            Create
          </CButton>
          <CButton
            v-if="!isNewOrganization"
            v-on:click="isCreateOrEditOrganization = false; updateOrganization();"
            color="success"
            :disabled="!isValidSelectedOrganization"
          >
            Save
          </CButton>
          
          
        </template>
      </CModal>
    </div>
    <Snackbar :isActivated="isAlert" :message="alertMessage" :color="alertColor"></Snackbar>
  </div>
</template>

<script>
import config  from '@/config'
import { axiosInstance } from '@/api'
// import { range, parseQueryString, parseBoolString, stringToHex } from '@/utils'
import Snackbar from '@/vue/base/Snackbar.vue'
import '@/assets/scss/search_box.scss'

import Ajv from "ajv"
import { TRUE } from 'sass'
const ajv = new Ajv()

export default {
  name: 'Info',
  components: { Snackbar },
  data () {
    return {
      isDeletabled: false,
      isManageInfo: false,
      isManageOrganization: false,
      isCreateOrEditOrganization: false,
      // isDeleteInfo: false,
      isAlert: false,
      alertCountDown: 0,
      alertColor: 'info',
      alertMessage: '',
      findKeyword: '',
      feedback: {},
      user: {},
      InfoSchema: {},
      info: {},
      selectedInfo: {},
      // updatedInfo: {},
      OrganizationSchema: {},
      organization: {},
      selectedOrganization: {},
      organizations: [],
      organizationsTableFields:  [
        { key: 'nameTH', label: 'องค์กร' },
        // { key: 'nameEN', label: 'Organization' },
        { key: 'nameShortTH', label: 'องค์กร (ย่อ)' },
        { key: 'nameShortEN', label: 'Organization (acronym)' },
        { key: 'operation', label: 'Operation' }
      ],
    }
  },
  computed: {
    // alertOrganizationEmpty () {
    //   if (this.organization) {
    //     return false
    //   }
    //   return true
    // },
    organizationsTable () {
      let organizations = []
      for(let i = 0; i < this.organizations.length; i++) {
        organizations.push(Object.assign({},this.organizations[i]))
      }
      
      let filteredOrganizations = []
      for(let i = 0; i < organizations.length; i++) {
        if (
          organizations[i]['nameTH'].includes(this.findKeyword)
          // || organizations[i]['nameEN'].includes(this.findKeyword)
          || organizations[i]['nameShortEN'].includes(this.findKeyword)
          || organizations[i]['nameShortEN'].toLowerCase().includes(this.findKeyword)
          || organizations[i]['nameShortTH'].includes(this.findKeyword)
        ) {
          filteredOrganizations.push(organizations[i])
        }
      }
      return filteredOrganizations
      // return organizations
    },
    isValidSelectedInfo () {
      const isValid = ajv.validate(this.InfoSchema, this.selectedInfo)
      if (!isValid) { 
        return false
      } else {
        return true
      }
    },
    isValidSelectedOrganization () {
      const isValid = ajv.validate(this.OrganizationSchema, this.selectedOrganization)
      if (!isValid) { 
        return false
      } else {
        return true
      }
    },
    isNewOrganization () {
      if(Object.hasOwn(this.selectedOrganization, 'id')) {
        if (typeof this.selectedOrganization.id === 'number') {
          return false
        }
      }
      return true
    },
    isOrganizationExist () {
      if (this.user) {
        if (typeof this.user.organizationId === 'number') {
          return true
        }
      }
      return false
    },
  },
  mounted() {
    this.getInfoSchema()
    this.getInfo()
    this.getUser()
    // this.getOrganization()
    this.getOrganizationSchema()
  },
  watch: {
    // isAdministrator(newValue, oldValue) {
    //   console.log('isAdministrator change')
    // },
  },
  methods: {
    isValidOrganization (key) {
      if (this.OrganizationSchema) {
        if(Object.hasOwn(this.selectedOrganization, key)) {
          // console.log('key: '+ key +' is exist')
          const isValid = ajv.validate(this.OrganizationSchema.properties[key], this.selectedOrganization[key])
          if (isValid) {
            return true
          } else {
            this.feedback[key] = ajv.errors[0].message
            return false
          }
        } 
        else {
          return false
        }
      } else {
        return false
      }
    },
    isValidInfo (key) {
      if (this.InfoSchema) {
        if(Object.hasOwn(this.selectedInfo, key)) {
          // console.log('key: '+ key +' is exist')
          // this.updatedInfo = Object.assign({},this.selectedInfo)
          const isValid = ajv.validate(this.InfoSchema.properties[key], this.selectedInfo[key])
          if (isValid) {
            return true
          } else {
            this.feedback[key] = ajv.errors[0].message
            return false
          }
        } 
        else {
          // console.log('key: '+ key +' is not exist')
          return false
        }
      } else {
        return false
      }
    },
    handleKeyword () {
      // Nothing to do, the keyword is used in computed()
    },
    // handleSelectedOrganization (organization) {
    //   this.selectedOrganization = organization
    // },
    handleManageOrganization () {
      this.isManageOrganization = true
      this.isCreateOrEditOrganization = false
      this.getOrganization()
      

      // let data = Object.assign({},this.info)
      // delete data.createdAt
      // delete data.updatedAt
      // this.selectedInfo = data
    },
    handleManageInfo () {
      this.isManageInfo = true
      this.isCreateMode = false

      let data = Object.assign({},this.info)
      if(!data.phone_ext) {
        data.phone_ext = ""
      }
      delete data.createdAt
      delete data.updatedAt
      this.selectedInfo = data
    },
    handleCreateOrUpdateInfo() {
      if (this.info && this.info.id) {
        this.updateInfo()
      } else {
        this.createInfo()
      }
    },
    getOrganizationSchema () {
      axiosInstance({
        method: 'get',
        url: '/organization/schema'
      })
      .then(response => {
        if(response.status === 200) {
          let schemas = {}
          Object.assign(schemas, response.data)
          let properties = {}
          Object.assign(properties, schemas.properties)
          delete schemas.properties
          schemas.properties = {}
          for (const [key, value] of Object.entries(properties)) {
            delete value.hint
            schemas.properties[key] = value
          }
          this.OrganizationSchema = schemas
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getOrganization () {
      axiosInstance({
        method: 'get',
        url: '/organization/'
      })
      .then(response => {
        // console.log(`get Organization: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.organizations = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getOrganizationOfyourself () {
      axiosInstance({
        method: 'get',
        url: '/organization/self'
      })
      .then(response => {
        // console.log(`get Organization: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.selectedOrganization = response.data
          this.organization = JSON.parse(JSON.stringify(response.data))
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    updateOrganization () {
      axiosInstance({
        method: 'put',
        url: '/organization/',
        data: this.selectedOrganization
      })
      .then(response => {
        if(response.status === 200) {
          this.organization = response.data
          this.alertColor = 'success'
          this.alertMessage = 'update organization success'
          this.isAlert = !this.isAlert
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    createOrganization () {
      axiosInstance({
        method: 'post',
        url: '/organization/',
        data: this.selectedOrganization
      })
      .then(response => {
        if(response.status === 200) {
          this.organization = response.data
          this.alertColor = 'success'
          this.alertMessage = 'create organization success'
          this.isAlert = !this.isAlert

          // ### force update orgainzationId of user
          this.getUser()
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    getUser () {
      axiosInstance({
        method: 'get',
        url: '/user/getOrCreate',
      })
      .then(response => {
        if(response.status === 200 || response.status === 201) {
          // console.log('/user/getOrCreate response-data: '+JSON.stringify(response.data, null, 2))
          this.user = response.data
          if (typeof this.user.organizationId === 'number') {
            this.getOrganizationOfyourself()
          } else {
            this.alertColor = 'danger'
            this.alertMessage = 'Please update your organization'
            this.isAlert = !this.isAlert
          }
        } 
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    updateOrganizationOfUser (organization) {
      this.isManageOrganization = false
      // console.log('/user/updateOrganization organization: '+JSON.stringify(organization, null, 2))
      axiosInstance({
        method: 'post',
        url: '/user/updateOrganization',
        data: {
          id: organization.id
        }
      })
      .then(response => {
        if(response.status === 200 ) {
          // console.log('/user/updateOrganization response-data: '+JSON.stringify(response.data, null, 2))
          this.user = response.data
          this.selectedOrganization = organization
          // this.organization = organization
          this.organization = JSON.parse(JSON.stringify(organization))
        } 
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getInfoSchema () {
      axiosInstance({
        method: 'get',
        url: '/info/schema'
      })
      .then(response => {
        if(response.status === 200) {
          let schemas = {}
          Object.assign(schemas, response.data)
          let properties = {}
          Object.assign(properties, schemas.properties)
          delete schemas.properties
          schemas.properties = {}
          for (const [key, value] of Object.entries(properties)) {
            delete value.hint
            schemas.properties[key] = value
          }
          this.InfoSchema = schemas
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getInfo () {
      axiosInstance({
        method: 'get',
        url: '/info/'
      })
      .then(response => {
        // console.log(`get Info: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          if(response.data.length > 0) {
            this.info = response.data[0]
          }
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    updateInfo () {
      axiosInstance({
        method: 'put',
        url: '/info/',
        data: this.selectedInfo
      })
      .then(response => {
        if(response.status === 200) {
          this.info = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    createInfo () {
      axiosInstance({
        method: 'post',
        url: '/info/',
        data: this.selectedInfo
      })
      .then(response => {
        if(response.status === 200) {
          this.info = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
  // .table-header {
  //   font-size: 1rem;
  //   margin-bottom: -15px;
  // }

  /* Center align content in the first column */
  .align-center {
    // text-align: center;
    display: flex;
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
  }

  /* Right align content in the second column */
  .align-right {
    display: flex;
    align-items: right; /* Vertical alignment */
    justify-content: right; /* Horizontal alignment */
  }
</style>